import { all } from 'redux-saga/effects';
import userSagas from './userSagas';
import organizationSagas from './organizationSagas';
import bucketSagas from './bucketSagas';
import routeSagas from './routeSagas';
import reportSaga from './reportSaga';
import assetsSaga from './assetsSaga';
import tagsSaga from './tagsSaga';

export function* rootSagas() {
    yield all([
        userSagas(),
        organizationSagas(),
        bucketSagas(),
        routeSagas(),
        reportSaga(),
        assetsSaga(),
        tagsSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/sagas.js